<template>
	<div class="about-xs" style="position:relative;">

		<div class="aw-register-box about-box">
			<div class="mod-body clearfix gxgd">
				<div class="content   aboutx">
					<div>
						<h2 class="about-cs">演示说明</font>
						</h2> </br>
						<div class="about-t">
							&nbsp; &nbsp;&nbsp;&nbsp;该页面只支持表USER_INFO_T的SQL查询语句，购买服务后在练习页面可执行创建表、更新、查询等操作。
						</div>
						<h2 class="about-cs">在线sql编辑器</font></h2> 
						 
				 
							<div class="about-t">&nbsp; &nbsp;&nbsp; &nbsp;请在如下编辑框里编写查询语句，点击执行按钮查看结果,如下是一些说sql语句示例：</div>
							<span class="about-t">
								&nbsp; &nbsp;&nbsp; &nbsp;1、<span style="color: blue;">SELECT</span> * <span
									style="color: blue;">FROM</span> USER_INFO_T; </br>
								&nbsp; &nbsp;&nbsp; &nbsp;2、<span style="color: blue;">SELECT</span> USER_ID,USER_NAME
								<span style="color: blue;">FROM</span> USER_INFO_T; </br>
								&nbsp; &nbsp;&nbsp; &nbsp;3、<span style="color: blue;">SELECT</span> SEX,COUNT(*) <span
									style="color: blue;">FROM</span> USER_INFO_T <span style="color: blue;">GROUP
									BY</span> SEX ; </br>
								&nbsp; &nbsp;&nbsp; &nbsp;4、<span style="color: blue;">SELECT</span> <span
									style="color: blue;">
									MAX</span>(AGE) <span style="color: blue;">FROM</span> USER_INFO_T;
							</span></br>
							<div class="about-t">
							请在这里输入sql语句 <img :src="require('@/assets/image/demo/jiantou.png')"style="height: 57px;width: 69px;"> </br>
							</div>
							<demo-sql-run :value="sqlInfo"> </demo-sql-run>
					 
						 

						
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import SqlShow from '@/components/project/SqlShow.vue'
	import DemoSqlRun from '@/components/project/DemoSqlRun.vue'
	export default {
		components: {

			DemoSqlRun,
			SqlShow,
		},

		data() {
			return {
				sqlInfo: 'select * from USER_INFO_T;',
				demoSql: 'CREATE TABLE USER_INFO_T ( \r\n' +
					'   USER_ID  		VARCHAR(100) 	NOT NULL     COMMENT  \'用户ID\',\r\n' +
					'   USER_NAME  		VARCHAR(200) 	NOT NULL     COMMENT  \'用户名称\',\r\n' +
					'   AGE 	    	  INT			  NOT NULL	   COMMENT  \'年龄\',\r\n' +
					'   HEIGHT      	  DECIMAL(10,2)  NOT NULL    COMMENT  \'身高\', \r\n' +
					'   SEX         	VARCHAR(1)     NOT NULL    COMMENT  \'性别\', \r\n' +
					'   CREATE_TIME  	DATETIME 		NOT NULL     COMMENT  \'记录创建时间\', \r\n' +
					'   PRIMARY KEY (USER_ID)\r\n' +
					')ENGINE=INNODB DEFAULT CHARSET=UTF8 COMMENT=\'用户信息表\' ;'
			}
		},

		created() {

		},
		computed: {

		},
		methods: {



		},

	}
</script>


<style lang="scss" scoped>
	//内容字体
	.about-t {
		height: auto;
		overflow: hidden;
		text-align: left;
		font-size: 20px;
		line-height: 60px;
	}

	.about-create {
		height: auto;
		overflow: hidden;
		text-align: left;
		font-size: 14px;
		line-height: 30px;
	}

	//标题字体
	h2.about-cs {
		padding-top: 10px;
		color: #2d8cf0;
		font-size: 24px;
		height: 50px;
		text-align: left;
		font-weight: bold;
	}

	.about-box {
		width: 1220px;
		margin: 20px;
		background-color: #fff;
		border-radius: 0;
		-webkit-box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		-moz-box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		box-shadow: 0 0 4px rgba(0, 0, 0, .1);
	}
</style>
